'use strict';

define('vb/private/stateManagement/variableFactory',['vb/private/stateManagement/variable',
  'vb/private/stateManagement/instanceFactoryVariable',
  'vb/private/stateManagement/implicitInstanceFactoryVariable',
  'vb/private/utils',
], (Variable, InstanceFactoryVariable, ImplicitInstanceFactoryVariable, Utils) => {
  /**
   * @typedef {import('vb/private/stateManagement/scope').default} Scope
   */

  /**
   * A variable factory that creates different kinds of variables based on its 'type'
   *   - primitive (uses variable.js)
   *   - object (- do -)
   *   - extended type class (- do -): 'vb/ServiceDataProvider', 'fa/SearchDataProvider'
   *   - any old type with no 'constructorParams' property: { type: 'oj/someRandomOJClass' }
   *
   *   - all other types (uses instanceFactoryVariable.js) - any type that has a 'constructorParams' property will be
   *    considered this new kind of variable. A fresh instance of the type is created every time its state changes.
   *    It's state is really its 'constructorParams'
   */
  class VariableFactory {
    /**
     * Creates either a regular Variable or a InstanceFactoryVariable.
     * TODO: The current 'ExtendedType' variables are going to need some special casing
     * @param {*} type The type of the variable (see StateUtils.getType() for type details)
     * @param {object} options
     * @param {Scope} options.scope
     * @param {string} options.name The name of the variable
     * @param {string} options.namespace optional, defaults to "variables"
     * @param {*} options.type
     * @param {*} options.defaultValue
     * @param {*} options.initialValue
     * @param {object} options.descriptor optional, example: {writable: false}. overrides other values.
     * @param {object} [options.variableDef] optional variable definition forwarded to the Variable constructor flow.
     * For a full list of properties see constructor for Variable and InstanceFactoryVariable.
     * @return {InstanceFactoryVariable | Variable } variable instance
     */
    static createVariable(type, options) {
      const argsArr = (options && Object.values(options)) || [];
      let Clazz;

      if (Utils.isImplicitTypeDefInstanceFactory(type)) {
        Clazz = ImplicitInstanceFactoryVariable;
      } else if (Utils.isTypeDefInstanceFactory(type)) {
        Clazz = InstanceFactoryVariable;
      } else {
        Clazz = Variable;
      }

      return new Clazz(...argsArr);
    }
  }

  return VariableFactory;
});

